
import Vue from 'vue';
import axios from "axios";
import { FacilityProperties} from '../../types/Sapphire_dto';
import FullCalendar from "@fullcalendar/vue";
import { CalendarOptions, EventClickArg, CalendarApi, EventApi} from '@fullcalendar/core'
import dayGridPlugin from "@fullcalendar/daygrid";
import timeGridPlugin from "@fullcalendar/timegrid";
import interactionPlugin from "@fullcalendar/interaction";
import eventTooltip from "./shared/eventTooltip.vue";
import CustomEventMenu from "./shared/CustomEventMenu.vue";
import ConsultClaimPopup, {ConsultClaimPopupRef} from './shared/ConsultClaimPopup.vue'
// import $ from "jquery";

export default Vue.extend({
  name: "consult-calendar-vue-component",
  components: {
    FullCalendar,
    eventTooltip,
    CustomEventMenu,
    ConsultClaimPopup
  },
  props: {
    facID: String,
  },
  computed: {
    ConsultClaimComponent(): ConsultClaimPopupRef {
      return this.$refs.ConsultClaimPopupComponent as ConsultClaimPopupRef;
    },
  },
  data: function () {
    
    const vm = this;
    //console.log(vm);

    return {
      busy: true,
      dismissCountDown: 0,
      selectedConsultFilterID: 0,
      consultFilterList: [
        { text: "Active", value: 0, buttonVariant: "taskNotDone" },
        { text: "Completed", value: 1, buttonVariant: "taskCompleted" },
        { text: "Rescheduled", value: 2, buttonVariant: "taskRescheduled" },
        { text: "Deleted", value: 3, buttonVariant: "taskCanceled" },
      ],
      selectClaimFilterID: 0,
      claimFilterList: [
        { text: "All", value: 0, buttonVariant: "taskCompleted" },
        { text: "Paid", value: 1, buttonVariant: "paidClaim" },
        { text: "Unpaid", value: 2, buttonVariant: "unpaidClaim" },
        { text: "No Claim", value: 3, buttonVariant: "noClaim" },
        { text: "Denied", value: 4, buttonVariant: "DeniedClaim" },
      ],
      dateFilterTo: new Date(),
      currentClickInfo: new Object(),
      currentEvent: new Object() as EventApi,
      mouseInfo: new Object(),
      openTooltip: false,
      openCustomEventMenu: false,
      showDatepicker: false,
      calendarAPI: new Object() as CalendarApi,
//      calendarOptions: new Object() as CalendarOptions,
      calendarOptions: {
        plugins: [
          dayGridPlugin,
          timeGridPlugin,
          interactionPlugin, // needed for dateClick
        ],
        headerToolbar: {
          left: "prev,next today",
          center: "title",
          right: "dayGridMonth,timeGridWeek,timeGridDay",
        },
        customButtons: {
          prev: {
            // this overrides the prev button
            text: "PREV",
            click: vm['customPrevButton'],
          },
          next: {
            // this overrides the next button
            text: "NEXT",
            click: vm['customNextButton'],
          },
        },        initialView: "dayGridMonth",
        // initialEvents: INITIAL_EVENTS, // alternatively, use the `events` setting to fetch from a feed
        aspectRatio: 1.75,
        editable: true,
        //selectable: true,
        dayMaxEvents: true,
        weekends: true,
        displayEventTime: true,
        eventDisplay: "block",
        events: vm['getCalendarEvents'],
        viewDidMount: vm['getCalendarEvents'],
        eventClick: vm['handleEventClick'],
        eventMouseEnter: vm['eventMouseover'],
        eventMouseLeave: vm['eventMouseout'],
        loading: vm['busy'],
        dateClick: vm['handleDateClick'],
        initialDate: vm['dateFilterTo'],
        datesSet: vm['viewChanged'],
        
      } as CalendarOptions,
      facSettings: new Object() as FacilityProperties,
    };
  },
  mounted() {
    this.calendarAPI = (this.$refs.fullCalendarComponent as InstanceType<typeof FullCalendar>).getApi();
    this.getFacSettings();
  },
  watch: {
     dateFilterTo: function (newVal, oldVal) {
      if (newVal != oldVal) {
        // this.calendarApi = this.$refs.fullCalendar.getApi();
        this.calendarAPI.gotoDate(this.dateFilterTo);
        this.getCalendarEvents();
        Array.from(document.querySelectorAll('.fc-state-highlight')).forEach((el) => el.classList.remove('fc-state-highlight'));
        var elem = document.querySelector(`td[data-date="${this.dateFilterTo}"]`);
        if (elem)
          elem.classList.add('fc-state-highlight');
      }
    }, 
    selectedConsultFilterID: function (newVal, oldVal) {
      if (newVal != oldVal) {
        this.getCalendarEvents();
      }
    },
    selectClaimFilterID: function (newVal, oldVal) {
      if (newVal != oldVal) {
        this.getCalendarEvents();
      }
    },
    facID: function (newVal, oldVal) {
      if (newVal != oldVal) {
        this.selectedConsultFilterID = 0;
        this.getCalendarEvents();
      }
    },
  },
  methods: {
    OpenConsultClaimPopup() {
      // Fill in what you need from the event they clicked on the context menu.
      this.ConsultClaimComponent.showPopup();
      this.hideEventMenu();
    },
    customPrevButton() {
      this.calendarAPI.prev();
      this.getCalendarEvents();
    },
    customNextButton() {
      this.calendarAPI.next();
      this.getCalendarEvents();
    },
    viewChanged() {
      this.openCustomEventMenu = false;
      this.openTooltip = false;
    },
    onContext(ctx) {
      if (ctx)
        // The following will be an empty string until a valid date is entered
        this.dateFilterTo = ctx.selectedYMD;
    },
    openTooltipDetails: function() {
      this.openCustomEventMenu = false;
      this.openTooltip = true;
    },
    handleDateClick: function(info) {
      this.dateFilterTo = info.dateStr;
      this.openCustomEventMenu = false;
      this.openTooltip = false;
      // Array.from(document.querySelectorAll('.fc-state-highlight')).forEach((el) => el.classList.remove('fc-state-highlight'));
      // info.dayEl.classList.add('fc-state-highlight');
    },
    handleWeekendsToggle() {
      this.calendarOptions.weekends = !this.calendarOptions.weekends; // update a property
    },
    handleEventClick(clickInfo: EventClickArg) {
      //We should toggle the menu when the user clicks the event object.
      this.openCustomEventMenu = !this.openCustomEventMenu;
      this.currentEvent = clickInfo.event;
      this.mouseInfo = clickInfo.jsEvent;
      this.openTooltip = false;
    },

    async getReleasePatients () {
      console.log("here");

      this.busy = true;
      let num = Number(this.facID);

      if (!isNaN(num)) {

        let response = await axios.post("../../../Common/Services/EhrTaskService.svc/GetConsultReleasedPatients",
                    {
                        facilityID: this.facID,
                        startWindow: this.calendarAPI.view.activeStart,
                        endWindow: this.calendarAPI.view.activeEnd,
                    }
                );         
                const contentType = 'application/pdf';
                const b64Data = JSON.parse(response.data.d);
                const blob = b64toBlob(b64Data, contentType);
                var fileURL = window.URL.createObjectURL(blob);
                var fileLink = document.createElement('a');
                
                fileLink.href = fileURL;
                fileLink.setAttribute('download', 'ReleasedPatients.pdf');
                document.body.appendChild(fileLink);
                fileLink.click();
      }
      this.busy = false;

    },

    async hideEventMenu() {
       this.openCustomEventMenu = false;
    },
    async getCalendarEvents() {
      this.busy = true;
      this.calendarOptions.events = [];
      this.openCustomEventMenu = false;
      this.openTooltip = false;
      let num = Number(this.facID);

      if (!isNaN(num)) {

        await axios
          .post(
            "../../../Common/Services/EhrTaskService.svc/GetConsultCalendarEvents",
            {
              facilityID: this.facID,
              startWindow: this.calendarAPI.view.activeStart,
              endWindow: this.calendarAPI.view.activeEnd,
              consultFilterID: this.selectedConsultFilterID,
              claimFilterID: this.selectClaimFilterID,
            }
          )
          .then((response) => {
            this.calendarOptions.events = JSON.parse(response.data.d);
          })
          .catch(function () {
            // handle error
            // eslint-disable-next-line no-undef
            // tb_remove2();
          });
      }
      this.busy = false;
    },
    hidePopup: function () {
      this.openTooltip = false;
    },
    
    showAlert() {
      this.dismissCountDown = 4; // Set your desired countdown value
    },
    async getFacSettings() {
            const response = await axios.post("../../Common/Services/EmarClientOperations.svc/GetFacilitySettings")
            this.facSettings = JSON.parse(response.data.d);      
    },
    
    
    // handleEventMount(calEventInfo) {
    //   const eventId = calEventInfo.event.id;
    //   calEventInfo.el.addEventListener("contextmenu", (jsEvent)=>{
    //     jsEvent.preventDefault()
    //     console.log("contextMenu", eventId)
    //   });
    // }
  },
});

function b64toBlob(b64Data: string, contentType='', sliceSize=512) {
        const byteCharacters = atob(b64Data);
        const byteArrays = [];

        for (let offset = 0; offset < byteCharacters.length; offset += sliceSize) {
            const slice = byteCharacters.slice(offset, offset + sliceSize);

            const byteNumbers = new Array(slice.length);
            for (let i = 0; i < slice.length; i++) {
            byteNumbers[i] = slice.charCodeAt(i);
            }

            const byteArray = new Uint8Array(byteNumbers);
            byteArrays.push(byteArray);
        }

        const blob = new Blob(byteArrays, {type: contentType});
        return blob;
    }
